import { useRouter } from 'next/router';

import useBoolean from '@hooks/useBoolean';
import { useDisplayType } from 'hooks/useDisplayType';
import { useUserData } from 'state/userData';
import { ComponentHeader } from 'types/componentTypes';

import CreateNewOrganization from './CreateNewOrganization/CreateNewOrganization';
import HeaderLG from './HeaderLG';
import HeaderSM from './HeaderSM';

const noBorderPages = ['sign-up', 'profile-invitations', 'tp/'];

const GloProsHeader: React.FC<ComponentHeader> = (props) => {
    const { value: isOpenNewOrganization, setValue: setIsOpenNewOrganization } =
        useBoolean();

    const { isMobile } = useDisplayType();
    const { asPath } = useRouter();

    const { user } = useUserData();
    const activeOrganization = user.activeCompany;

    const hasBorder = !noBorderPages.some((str) => asPath.includes(str));

    const modifiedProps = {
        ...props,
        withBorder: hasBorder,
        setIsOpenNewOrganization,
    };

    return (
        <>
            {isMobile ? (
                <HeaderSM {...modifiedProps} />
            ) : (
                <HeaderLG {...modifiedProps} />
            )}

            <CreateNewOrganization
                isOpen={isOpenNewOrganization}
                setOpen={setIsOpenNewOrganization}
                groupSlug={activeOrganization?.company_groups?.slug}
            />
        </>
    );
};

export default GloProsHeader;
